<template>
	<div class="page container">
		<v2-back-btn />
		<div class="page__info">
			<div class="page__info--title">
				{{ getTitle }}
			</div>
			<span data-element="notification-date">{{ getDate }}</span>
		</div>
		<div class="content">
			<div class="main">
				<div
					data-element="content"
					v-html="getContent"
				/>
			</div>
		</div>
	</div>
</template>

<script>

	import V2BackBtn from '@/components/v2/ui/V2BackBtn';
	import api from '@/services/api';
	import dayjs from 'dayjs';
	import sanitizeHtml from 'sanitize-html';

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Notification'
		},
		components: {
			V2BackBtn
		},
		data () {
			return {
				notification: null
			};
		},
		computed: {
			getNotificationId () {
				return this.$route.params.notificationId;
			},
			getTitle () {
				if (this.notification) {
					return this.notification.title;
				}
				return null;
			},
			getContent () {
				if (this.notification) {
					return sanitizeHtml(this.notification.content, {
						allowedTags: ['strong', 'em', 'ul', 'ol', 'li', 'p', 'br', 'span', 'a'],
						allowedAttributes: {
							li: ['data-list'],
							span: ['class', 'data-colour', 'data-element'],
							a: ['href', 'target', 'class', 'data-glossary-slug']
						}
					});
				}
				return null;
			},
			getDate () {
				if (this.notification) {
					return dayjs(this.notification.publishedAt).format('DD/MM/YYYY HH:mm');
				}
				return null;
			},
			getBreadcrumbs () {
				return [
					{
						path: '/notifications',
						text: 'Notifications'
					},
					{
						path: `/notifications/${this.getNotificationId}`,
						text: this.getTitle
					}
				];
			}
		},
		async created () {
			await this.fetchNotification();
			this.$store.commit('ui/setLoadingIsHidden');
			this.$store.dispatch('notifications/getNotificationsUnreadCount').catch(console.error);
		},
		methods: {
			async fetchNotification () {
				const notification = await api.notifications.getNotificationsById(this.getNotificationId);
				if (!notification) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.notification = notification;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
			}
		}
	};

</script>

<style lang="scss" scoped>

.page__info {
	margin-bottom: 24px;

	[data-element='notification-date'] {
		font-size: 14px;
		color: $c-gray-d3;
	}
}

.content {
	.main {
		::v-deep [data-element='content'] {
			font-size:rem(20);
			@include rich-text-content;
			@include rich-text-suits;

			ul,
			ol {
				li {
					&[data-list="bullet"] {
						list-style-type: disc;
					}
				}
			}
		}
	}

	@media (max-width: 1279px) {
		display: flex;
		flex-direction: column;

		.main {
			width: 100%;
		}
	}
}

</style>
